import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Seo from "@/shop/Seo";
import { apiGet } from "@/shop/api";
import ProductCard from "@/components/shop/ProductCard";

export default function EditionsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    apiGet("/api/shop/products?product_type=edition&sort=newest")
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-ink text-bone min-h-screen" data-testid="editions-list">
      <Seo
        title="Editions — Stillwater"
        description="Carta stampata, fotografia, abbigliamento e collaborazioni in edizione limitata, prodotte da Stillwater."
        canonical="https://stillwatermag.eu/shop/editions"
      />
      <header className="px-5 md:px-10 pt-28 md:pt-36 pb-10 md:pb-16 border-b border-ink-border">
        <p className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-4">
          Shop — Edizioni
        </p>
        <h1 className="font-serif font-light text-4xl md:text-6xl tracking-tight">
          Stillwater <span className="italic text-ember">Editions</span>
        </h1>
        <p className="mt-4 max-w-xl text-sm md:text-base text-mist leading-relaxed">
          Ciò che produciamo noi: stampa, fotografia, capi e collaborazioni
          numerate. Vicini agli oggetti da libreria che ai capi da pesca.
        </p>
      </header>

      <div className="px-5 md:px-10 py-12">
        {!loading && items.length === 0 && (
          <div className="border border-ink-border bg-ink-surface px-6 py-16 text-center" data-testid="editions-empty">
            <p className="font-serif italic text-2xl">Le Edizioni sono in preparazione.</p>
            <p className="mt-3 text-sm text-mist">
              Il primo pezzo numerato uscirà qui, senza rumorismo.
            </p>
          </div>
        )}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-7">
          {items.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: (i % 6) * 0.07, ease: [0.16, 1, 0.3, 1] }}
            >
              <ProductCard p={p} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
